import React from "react";

import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

const types = [
  { name: "CAS", value: "cas" },
  { name: "Azure", value: "azure" },
];

function FormTypeSelect({ type, select }: Props) {
  const selectedType = types.find(({ value }) => value === type);

  return (
    <SelectList
      rootClassName={styles.formTypeSelect}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p className={styles.name}>
              {selectedType ? selectedType.name : types[0].name}
            </p>
            <div className={styles.iconBox}>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {types.map((type) => (
              <div
                key={type.value}
                className={styles.item}
                onClick={() => s(select(type.value))}
              >
                {type.name}
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { FormTypeSelect };
